/**
 * Shared fake user shape for dev-auth-bypass mode. Used by both the
 * client (useUser) and server (getCurrentUser) helpers so the rest of
 * the app sees a consistent identity regardless of which surface it
 * reads from.
 */

export const DEV_PREVIEW_USER_ID = 'dev-preview-user';
export const DEV_PREVIEW_EMAIL = 'dev-preview@example.test';

export const devPreviewUser = {
  id: DEV_PREVIEW_USER_ID,
  firstName: 'Preview',
  lastName: 'User',
  fullName: 'Preview User',
  // `verification` is read by the billing page to decide whether checkout is
  // allowed. The bypass user is treated as verified so that flow is reachable
  // locally; omitting it made every consumer of the real Clerk shape a type
  // error at the facade boundary.
  primaryEmailAddress: {
    emailAddress: DEV_PREVIEW_EMAIL,
    verification: { status: 'verified' as const },
  },
  emailAddresses: [
    { emailAddress: DEV_PREVIEW_EMAIL, verification: { status: 'verified' as const } },
  ],
  imageUrl: '',
  hasImage: false,
  publicMetadata: {},
  unsafeMetadata: {},
} as const;
